import { CityRO } from '@routellers/types/dist/city/city.ro';
import { CreateCityDto } from '@routellers/types/dist/city/create-city.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    data: CreateCityDto;
};

type ResponseData = CityRO;

export const create: ApiMethodDeclaration<ParamsData, ResponseData> = ({ data }) => ({
    url: '/cities',
    method: 'POST',
    data,
});
